"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatioBox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var StyledDiv = (0, styled_components_1.default)("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  height: 0;\n  padding-top: ", "%;\n  width: 100%;\n  position: relative;\n  & > * {\n    left: 0;\n    top: 0;\n    position: absolute;\n    display: block;\n    width: 100%;\n    height: 100%;\n    &,\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: ", ";\n      transition: transform 0.4s ease-out;\n    }\n  }\n\n  & > a,\n  & > button {\n    cursor: pointer;\n    &:hover {\n      img {\n        transform: scale(1.1);\n      }\n    }\n  }\n"], ["\n  overflow: hidden;\n  height: 0;\n  padding-top: ", "%;\n  width: 100%;\n  position: relative;\n  & > * {\n    left: 0;\n    top: 0;\n    position: absolute;\n    display: block;\n    width: 100%;\n    height: 100%;\n    &,\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: ", ";\n      transition: transform 0.4s ease-out;\n    }\n  }\n\n  & > a,\n  & > button {\n    cursor: pointer;\n    &:hover {\n      img {\n        transform: scale(1.1);\n      }\n    }\n  }\n"])), function (props) { return props.ratio * 100; }, function (props) { return props.objectPosition || "center"; });
var RatioBox = function (props) {
    var _a;
    var children = props.children;
    return ((0, jsx_runtime_1.jsx)(StyledDiv, __assign({}, props, { className: "wellms-component ".concat((_a = props.className) !== null && _a !== void 0 ? _a : "") }, { children: children })));
};
exports.RatioBox = RatioBox;
var templateObject_1;
